import axios, { AxiosError } from "axios";
import { useAuth0 } from "@auth0/auth0-react";
import { useContext, useEffect } from "react";
import { checkTokenExpired, getTokenFromStorage } from "../tokenFunctions";
import { AppContext } from "../contexts/AppContext";

export function useLogError() {
  const { pushAlert } = useContext(AppContext);
  return (error: AxiosError) => {pushAlert({
    title: "Error",
    // @ts-expect-error It should be a string
    text: error.response.data.error,
    closeButton: true,
    type: "error",
    time: 8000,
  })};
}

const useAxiosInterceptor = () => {
  const { logout } = useAuth0();
  const { pushAlert } = useContext(AppContext);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          // If a 401 Unauthorized response is detected, log out the user
          const tokenFromStorage = getTokenFromStorage();
          if (tokenFromStorage && checkTokenExpired(tokenFromStorage)) {
            console.log("Expired token!");
            logout({ logoutParams: { returnTo: window.location.origin } });
          }
        } else if (error.response && error.response.status === 403) {
          pushAlert({
            title: "Unauthorized",
            text: "You do not have the permissions to do this action!",
            closeButton: true,
            type: "error",
            time: 8000,
          });
        }
        return Promise.reject(error);
      },
    );

    // Eject the interceptor when the component unmounts to avoid memory leaks
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [logout, pushAlert]);
};

export default useAxiosInterceptor;
